import type { FaireProductEntity } from "../../entity_types/product";

export const caden_lane_16: FaireProductEntity = {
  token: "caden-lane-16",
  type: "product",
  name: "CuddleLane™ Luxe Blankets | Check",
  brandName: "Caden Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/04e1efd50b160247e20807f58c208d1757eb0550614002ab33f7934c8baad78d.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&width=720",
  priceDollars: 26,
  msrpDollars: 52,
  freeShipping: false,
  isBestseller: true,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_home-decor-bedding"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
